@use '../../../assets/styles/theme';

.flexContainer {
  display: flex;
  flex-wrap: wrap;
}

.alignItems {
  &--stretch {
    align-items: stretch;
  }
  &--center {
    align-items: center;
  }
  &--flexStart {
    align-items: flex-start;
  }
  &--flexEnd {
    align-items: flex-end;
  }
  &--baseline {
    align-items: baseline;
  }
  &--initial {
    align-items: initial;
  }
  &--inherit {
    align-items: inherit;
  }
}
.alignSelf {
  &--stretch {
    align-self: stretch;
  }
  &--center {
    align-self: center;
  }
  &--flexStart {
    align-self: flex-start;
  }
  &--flexEnd {
    align-self: flex-end;
  }
  &--baseline {
    align-self: baseline;
  }
  &--initial {
    align-self: initial;
  }
  &--inherit {
    align-self: inherit;
  }
}

.flexDirection {
  &--row {
    flex-direction: row;
  }
  &--column {
    flex-direction: column;
  }
}

.justifyContent {
  &--flexStart {
    justify-content: flex-start;
  }
  &--flexEnd {
    justify-content: flex-end;
  }
  &--center {
    justify-content: center;
  }
  &--spaceBetween {
    justify-content: space-between;
  }
  &--spaceAround {
    justify-content: space-around;
  }
  &--initial {
    justify-content: initial;
  }
  &--inherit {
    justify-content: inherit;
  }
}

.keepHeight {
  flex-direction: column;
  flex-grow: 1;
  min-height: 0;
  flex-basis: 0;
  height: 100%;
  flex-wrap: nowrap;
}

.noShrink {
  flex-shrink: 0;
}

.growToContainer {
  flex-grow: 1;
}

.noWrap {
  flex-wrap: nowrap;
}

.scroll {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
